import axios from "axios";
import { getAuthHeader, LOGOUT_URL } from "../../configuration/Utils/constService";

export const logOut = (data) => axios.post(LOGOUT_URL, data, getAuthHeader());